import React, { useContext, useEffect, useState } from "react";

import AuthContext from "../../contexts/AuthCtx";
import StatusMessage from "../UX/StatusMessage";
import { api } from "../../api/api";

function VitalStatusNotice({ hasSeenVitalStatusNotice = false }) {
  const AuthCtx = useContext(AuthContext);
  const [vitalCheck, setVitalCheck] = useState(null);
  const [dismissed, setDismissed] = useState(Boolean(hasSeenVitalStatusNotice));

  useEffect(() => {
    setDismissed(Boolean(hasSeenVitalStatusNotice));
  }, [hasSeenVitalStatusNotice]);

  useEffect(() => {
    if (!AuthCtx.userToken || dismissed) return;

    api
      .get("vital-check/", {
        headers: { Authorization: `Bearer ${AuthCtx.userToken}` },
      })
      .then(({ data }) => {
        if (data?.hasSeenVitalStatusNotice) {
          setDismissed(true);
          return;
        }
        setVitalCheck(data);
      })
      .catch(() => setVitalCheck(null));
  }, [AuthCtx.userToken, dismissed]);

  const handleDismiss = () => {
    setDismissed(true);
    setVitalCheck(null);
    api
      .post(
        "vital-check/dismiss",
        {},
        { headers: { Authorization: `Bearer ${AuthCtx.userToken}` } }
      )
      .catch(() => {});
  };

  if (dismissed || !vitalCheck) return null;

  // Always "à l'instant" — global VitalCheck.createdAt can be hours old and
  // confuses new users; this banner is a one-time reassurance, not a clock.
  return (
    <StatusMessage
      title="Statut vital actualisé"
      subtitle="à l'instant"
      variant="success"
      className="shrink-0 rounded-md"
      onDismiss={handleDismiss}
    />
  );
}

export default VitalStatusNotice;
